
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits/member-directory",
      function () {
        return require("private-next-pages/benefits/member-directory/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits/member-directory"])
      });
    }
  